export const convertToArray = <T>(item: T | T[] | null | undefined): T[] =>
	!item ? [] : Array.isArray(item) ? item : [item];
